import { LoginInfo } from '../models';

export class LoginInfoBuilder {
  private loginInfo: LoginInfo;

  constructor() {
    this.loginInfo = new LoginInfo();
  }

  public setEmail(value: string): LoginInfoBuilder {
    this.loginInfo.email = value;
    return this;
  }

  public setPassword(value: string): LoginInfoBuilder {
    this.loginInfo.password = value;
    return this;
  }

  public setHash(value: string): LoginInfoBuilder {
    this.loginInfo.hash = value;
    return this;
  }

  public setCompanyGuid(value: string): LoginInfoBuilder {
    this.loginInfo.companyGuid = value;
    return this;
  }

  //USE THIS ONLY IN DEVELOPMENT
  public setTestingFlag(): LoginInfoBuilder {
    this.loginInfo.testingFlag = 'ShortTokenExpiry';
    return this;
  }

  public build(): LoginInfo {
    return this.loginInfo;
  }
}
